export default {"src":"/_next/static/media/12-icon.77af23e9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};